module.exports = __webpack_public_path__ + "img/ivTest_sub65.e0801350.png";